var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      !_vm.mobileView
        ? _c("div", [
            _c("div", { attrs: { id: "registro" } }, [
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "14%" },
                  attrs: { id: "headerList-comprobante" }
                },
                [
                  _vm._v(
                    _vm._s(_vm.moment(_vm.item.Fecha).format("DD/MM/YYYY"))
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "14%" },
                  attrs: { id: "headerList-tipo" }
                },
                [_vm._v(_vm._s(_vm.tipo(_vm.item.Tipo)))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "14%" },
                  attrs: { id: "headerList-fecha" }
                },
                [_vm._v(_vm._s(_vm.item.Numero))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "14%" },
                  attrs: { id: "headerList-vencimiento" }
                },
                [_vm._v(_vm._s(_vm.fechaVencimiento))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "22%" },
                  attrs: { id: "headerList-monto" }
                },
                [_vm._v("$ " + _vm._s(_vm._f("formatMoney")(_vm.item.Importe)))]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "textHeaderList",
                  staticStyle: { width: "22%" },
                  attrs: { id: "headerList-saldo" }
                },
                [_vm._v(_vm._s(_vm._f("formatMoney")(_vm.item.Acum)))]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "separator",
              staticStyle: {
                width: "100%",
                height: "1px",
                "background-color": "#dddddd"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c("div", { staticClass: "oblea" }, [
            _c(
              "div",
              {
                staticClass: "fv lc",
                staticStyle: { width: "100%", height: "100%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      "font-weight": "500",
                      color: "#5D6770"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("Nro:")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.item.Numero))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      color: "#5D6770",
                      "font-weight": "500"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("Tipo:")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.tipo(_vm.item.Tipo)))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      color: "#5D6770",
                      "font-weight": "500"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("Fecha:")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.moment(_vm.item.Fecha).format("DD/MM/YYYY"))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "12px",
                      color: "#5D6770",
                      "font-weight": "500"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("Vencimiento:")
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.fechaVencimiento))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "13px",
                      "font-weight": "800",
                      "margin-top": "10px",
                      color: "#5D6770"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("IMPORTE:")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "$ " + _vm._s(_vm._f("formatMoney")(_vm.item.Importe))
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh cc",
                    staticStyle: {
                      "margin-left": "20px",
                      "font-size": "13px",
                      "font-weight": "800",
                      "margin-top": "5px",
                      color: "#5D6770"
                    }
                  },
                  [
                    _c("div", { staticStyle: { width: "100px" } }, [
                      _vm._v("SALDO ACUM:")
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "$ " + _vm._s(_vm._f("formatMoney")(_vm.item.Acum))
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4738f13d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4738f13d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ctacte/item.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4738f13d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ctacte/item.vue
// module chunks = 0